(function () {
  'use strict';

  var STORAGE_REF   = 'ecx_ref';
  var STORAGE_EXP   = 'ecx_ref_exp';
  var STORAGE_DATE  = 'ecx_clic_date';
  var API_BASE      = window.ECX_API || '';
  var TTL_DIAS      = 1;

  // 1. Capturar ?ref= si viene en la URL, reinicia el contador de 30 días
  var params = new URLSearchParams(window.location.search);
  var ref = params.get('ref');
  if (ref) {
    var clean = ref.toLowerCase().replace(/[^a-z0-9_-]/g, '').slice(0, 30);
    if (clean) {
      localStorage.setItem(STORAGE_REF, clean);
      var exp = Date.now() + TTL_DIAS * 24 * 60 * 60 * 1000;
      localStorage.setItem(STORAGE_EXP, String(exp));
    }
  }

  // 2. Leer alias, respetar expiración de 30 días
  var alias = localStorage.getItem(STORAGE_REF);
  var expTs = parseInt(localStorage.getItem(STORAGE_EXP) || '0', 10);
  if (!alias || (expTs && Date.now() > expTs)) {
    localStorage.removeItem(STORAGE_REF);
    localStorage.removeItem(STORAGE_EXP);
    localStorage.removeItem(STORAGE_DATE);
    return;
  }

  // 3. Registrar clic solo si llegó ?ref= en esta visita y no lo registramos hoy
  if (ref) {
    var today = new Date().toISOString().slice(0, 10);
    if (localStorage.getItem(STORAGE_DATE) !== today) {
      fetch(API_BASE + '/api/v1/embajadores/clic', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ alias: alias }),
      })
        .then(function () { localStorage.setItem(STORAGE_DATE, today); })
        .catch(function () {});
    }
  }

  // 4. Inyectar cart attribute para que el ref llegue a la orden
  function setCartRef() {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { ref: alias } }),
    }).catch(function () {});
  }

  setCartRef();

  // Re-inyectar si el carrito se actualiza (tema Dawn usa evento custom)
  document.addEventListener('cart:refresh', setCartRef);
  document.addEventListener('cart:updated', setCartRef);
})();
